'use strict';

var React = require('react');
module.exports = React.createContext({
  rootIsQueryRenderer: false
});